import { render, staticRenderFns } from "./destroy-proposal-buttons.vue?vue&type=template&id=247615cb&lang=pug"
import script from "./destroy-proposal-buttons.vue?vue&type=script&lang=js"
export * from "./destroy-proposal-buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports